import { PAYMENT_MULTI_STEPS } from '../../utils/steps';
import { StepPerformanceWrapper } from '../atoms/step-performance-wrapper';
import { CareCreditMessageNavigationSwitch } from './care-credit-message/care-credit-message-navigation-switch';

export const CareCreditMessage = () => {
  return (
    <StepPerformanceWrapper step={PAYMENT_MULTI_STEPS.careCreditMessage}>
      <CareCreditMessageNavigationSwitch />
    </StepPerformanceWrapper>
  );
};
